const Project = ({ img, date, title, text, city, days, price }) => {
  return (
    <article className='project-card'>
      <div className='project-img-container'>
        <img src={img} className='project-img' alt={" "} />
        <p className='project-date'>{date}</p>
      </div>
      <div className='project-info'>
        <div className='project-title'>
          <h4>{title}</h4>
        </div>
        <p>{text}</p>
        <div className='project-footer'>
          <p>
            <span>
              <i className='fas fa-map'></i>
            </span>
            {city}
          </p>
          <p>{days}</p>
          <p>Cost {price}</p>
        </div>
      </div>
    </article>
  );
};
export default Project;
